/**
 * WooCommerce scrolls to its notices (the errors after a failed checkout, for one) leaving a fixed 100px above
 * them, and to the checkout login box leaving 50px. The fixed header with the announcement bar is taller than
 * both, so they ended up underneath it.
 */

const GAP = 20;

const scrollBelowHeader = ($element, duration) => {
  const header = document.querySelector('.header');

  jQuery('html, body').animate({
    scrollTop: $element.offset().top - (header ? header.offsetHeight : 0) - GAP
  }, duration);
};

// In a ready callback so that it runs after woocommerce.js, which defines its own version in one.
jQuery(($) => {
  $.scroll_to_notices = (scrollElement) => {
    if (scrollElement.length) {
      scrollBelowHeader(scrollElement, 1000);
    }
  };
});

// The links that open the checkout login box: "Click here to login", and "Please log in." in an error. Taken
// over in the capture phase, ahead of WooCommerce's own handler and of scroll-to-hash.js, which sends "#" links
// to the top of the page.
document.addEventListener('click', (e) => {
  const $form = jQuery('form.login, form.woocommerce-form--login');

  if (!e.target.closest('a.showlogin') || !$form.length) {
    return;
  }

  e.preventDefault();
  e.stopPropagation();

  const opening = !$form.is(':visible');

  $form.slideToggle(400, () => opening && scrollBelowHeader($form, 300));
}, true);
